export default __webpack_public_path__ + "static/media/marker-dropoff.3bbb5d06.svg";